const MorePageLinkBanner = ({ children }: { children: React.ReactNode }) => {
  return (
    <section className="bg-gray-50 py-16">
      <h2 className="text-gray-700 font-semibold text-xl md:text-2xl text-center">
        Still can&rsquo;t find what you&rsquo;re looking for ?
        <span className="text-primary"> Try here</span>{" "}
      </h2>
      <div className="pb-10 mt-12 container mx-auto flex  flex-wrap lg:flex-nowrap justify-center gap-x-6 gap-y-3">
        {children}
      </div>
    </section>
  );
};

export default MorePageLinkBanner;
